import { render } from "./AdminLinkRouter.vue?vue&type=template&id=6d982a74&scoped=true"
import script from "./AdminLinkRouter.vue?vue&type=script&lang=js"
export * from "./AdminLinkRouter.vue?vue&type=script&lang=js"

import "./AdminLinkRouter.vue?vue&type=style&index=0&id=6d982a74&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebasedevdemo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d982a74"]])

export default __exports__